"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PrepaInAds {
    constructor() {
        var _a, _b;
        this.lightboxDismissalKey = "prepain_ads_lightbox_dismissed_until";
        this.lightboxDismissalDuration = 24 * 60 * 60 * 1000;
        this.horizontalAds = [];
        this.verticalAds = [];
        this.currentHorizontalAd = null;
        this.loadedAds = new Set();
        this.trackedImpressions = new Set();
        this.trackingEndpoint = "";
        this.trackingNonce = "";
        this.lightbox = document.getElementById("ads-lightbox");
        this.closeButton = this.lightbox
            ? this.lightbox.querySelector("button")
            : null;
        this.adsHorizontalContainer = document.querySelector(".prepain-ad-horizontal");
        this.adsVerticalContainer = document.querySelector(".prepain-ad-vertical");
        const data = window.prepainAdsData;
        if (data) {
            this.horizontalAds = data.horizontal || [];
            this.verticalAds = data.vertical || [];
            this.trackingEndpoint = ((_a = data.tracking) === null || _a === void 0 ? void 0 : _a.endpoint) || "";
            this.trackingNonce = ((_b = data.tracking) === null || _b === void 0 ? void 0 : _b.nonce) || "";
        }
        this.appendRandomAsset();
    }
    appendRandomAsset() {
        if (this.horizontalAds.length > 0) {
            const chosen = this.horizontalAds[Math.floor(Math.random() * this.horizontalAds.length)];
            this.currentHorizontalAd = chosen;
            this.setupAdContainer(this.adsHorizontalContainer, chosen);
        }
        if (this.verticalAds.length > 0) {
            const chosen = this.verticalAds[Math.floor(Math.random() * this.verticalAds.length)];
            this.setupAdContainer(this.adsVerticalContainer, chosen);
        }
    }
    setupAdContainer(container, adConfig) {
        if (!container)
            return;
        const img = this.createImageElement(adConfig);
        img.addEventListener("load", () => this.handleImageLoaded(adConfig));
        container.appendChild(img);
        container.setAttribute("href", adConfig.url);
        container.setAttribute("target", adConfig.target);
        container.addEventListener("click", () => {
            this.trackAdClick(adConfig);
        });
        if (img.complete && img.naturalWidth > 0) {
            this.handleImageLoaded(adConfig);
        }
    }
    handleImageLoaded(adConfig) {
        var _a;
        this.loadedAds.add(adConfig.tracking_id);
        if (adConfig.type === "vertical" ||
            !((_a = this.lightbox) === null || _a === void 0 ? void 0 : _a.classList.contains("hidden"))) {
            this.trackImpression(adConfig);
        }
    }
    createImageElement(adConfig) {
        const img = document.createElement("img");
        img.src = adConfig.image_url;
        img.className = "w-full h-auto";
        img.alt = adConfig.id;
        return img;
    }
    trackAdClick(adConfig) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "prepain_ad_click",
            event_category: "prepain_ad",
            event_action: "click",
            event_label: adConfig.id,
        });
        this.sendTrackingEvent(adConfig, "click");
    }
    trackImpression(adConfig) {
        if (this.trackedImpressions.has(adConfig.tracking_id))
            return;
        this.trackedImpressions.add(adConfig.tracking_id);
        this.sendTrackingEvent(adConfig, "impression");
    }
    sendTrackingEvent(adConfig, event) {
        if (!this.trackingEndpoint ||
            !this.trackingNonce ||
            !adConfig.tracking_id) {
            return;
        }
        void fetch(this.trackingEndpoint, {
            method: "POST",
            credentials: "same-origin",
            keepalive: true,
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": this.trackingNonce,
            },
            body: JSON.stringify({
                tracking_id: adConfig.tracking_id,
                event,
            }),
        }).catch(() => {
            /* Analytics must never interrupt navigation or the student experience. */
        });
    }
    init() {
        if (!this.lightbox || this.horizontalAds.length === 0)
            return;
        // A dismissal is persistent across tabs and page visits, but expires after
        // 24 hours so the popup can be shown again the following day.
        if (this.isLightboxDismissed())
            return;
        this.showLightbox();
        this.setupEventListeners();
    }
    isLightboxDismissed() {
        try {
            const dismissedUntil = Number(localStorage.getItem(this.lightboxDismissalKey));
            if (Number.isFinite(dismissedUntil) && dismissedUntil > Date.now()) {
                return true;
            }
            localStorage.removeItem(this.lightboxDismissalKey);
        }
        catch (e) {
            /* localStorage blocked (private mode/quota) — fail open and show it */
        }
        return false;
    }
    showLightbox() {
        if (this.lightbox) {
            this.lightbox.classList.remove("hidden");
            this.lightbox.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
        }
        if (this.currentHorizontalAd &&
            this.loadedAds.has(this.currentHorizontalAd.tracking_id)) {
            this.trackImpression(this.currentHorizontalAd);
        }
    }
    hideLightbox() {
        if (this.lightbox) {
            this.lightbox.classList.add("hidden");
            this.lightbox.setAttribute("aria-hidden", "true");
            document.body.style.overflow = "";
        }
    }
    dismissLightbox() {
        try {
            localStorage.setItem(this.lightboxDismissalKey, String(Date.now() + this.lightboxDismissalDuration));
        }
        catch (e) {
            /* localStorage blocked (private mode/quota) — still close the popup */
        }
        this.hideLightbox();
    }
    setupEventListeners() {
        if (this.closeButton) {
            this.closeButton.addEventListener("click", () => this.dismissLightbox());
        }
        if (this.lightbox) {
            this.lightbox.addEventListener("click", (e) => {
                if (e.target === this.lightbox) {
                    this.dismissLightbox();
                }
            });
        }
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                this.dismissLightbox();
            }
        });
    }
}
exports.default = PrepaInAds;
